import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class MaxVerticalLines extends BaseOption {
  static userInterfaceComponent = {
    label: "Max Vertical Lines",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: 0,
    },
  };

  static defaultValue = 3;
}
